module.exports = __webpack_public_path__ + "7680f9ca666c2ac5e9f7528d30ef6b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201509_Presse_AVANGA_RN_1_1MB.jpg
// module id = 559
// module chunks = 0